// FahrerNew shows FahrerForm and FahrerFormReview
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reportVideoSeen, fetchFahrerByUuid } from '../../actions'
import VideoFragen from './VideoFragen'
import Vimeo from '@u-wave/react-vimeo'

class VideoDisplay extends Component {

	constructor(props) {
    super(props)
    this.state = {
      videoSeen: false,
			abschluss: false,
			fragenBlockNummer: null,
			phase: 'antwortphase',
			falscheAntworten: [1,1,1,1]
    }
		this.handleVideoEnded = this.handleVideoEnded.bind(this);
		this.handleFragenCheckClick = this.handleFragenCheckClick.bind(this);
		this.handleWeiterClick = this.handleWeiterClick.bind(this);
  }

	fahrerVorhanden() {
		return this.props.fahrer && this.props.fahrer.length > 0;
	}

	handleFragenCheckClick() {
		const a = this.state.falscheAntworten.slice();
		a[this.state.fragenBlockNummer] = this.refs.vf.hasFalseAnswers();
		this.setState({falscheAntworten: a});
		this.setState({phase: 'auswertungsphase'});
	}

	allesRichtig() {
		const reducer = (accumulator, reducer) => accumulator + reducer;
		return this.state.falscheAntworten.reduce(reducer) === 0;
	}

	handleWeiterClick() {
		console.log("alles richtig?", this.allesRichtig());

		if (this.allesRichtig()) {
			this.setState({abschluss: true});
			this.props.reportVideoSeen({uid: this.props.match.params.uid});
			return;
		}
		var n = this.state.fragenBlockNummer + 1;
		if (n > 3) {
			n = 0;
		}
		this.setState({phase: 'antwortphase', fragenBlockNummer: n});
	}

	handleVideoEnded() {
		this.setState({'videoSeen':true, 'fragenBlockNummer':0, phase: 'antwortphase'});
		console.log(this.props.match.params.uid);

		//this.props.reportVideoSeen({uid: this.props.match.params.uid});
	}

	componentDidMount() {
		const fahrer_uid = this.props.match.params.uid
		this.props.fetchFahrerByUuid(fahrer_uid);
	}

	//Video gesehen: <span>{this.state.videoSeen.toString()}</span>

	renderContent() {

		return (
			<div className="w-100 row">

				{this.fahrerVorhanden() && !this.state.abschluss && <p className="pl-3">
					Fahrer:<span>{this.props.fahrer[0].email}</span>
				</p>}
				{this.fahrerVorhanden() && !this.state.videoSeen &&
					<div className="row w-100 p-3">
						<Vimeo
							id="vimeoPlayer"
							video="https://player.vimeo.com/video/287221209"
							onEnd={(e) => this.handleVideoEnded()}
							showTitle={false}
							width={800}
							byline={false}
							autoplay={true} />
					</div>
					}
				{this.fahrerVorhanden() &&  this.state.videoSeen && !this.state.abschluss &&
					<React.Fragment>
						<VideoFragen ref="vf" blockNummer={this.state.fragenBlockNummer} phase={this.state.phase} />
						<div className="pl-3">
						{this.state.phase !== 'auswertungsphase' &&
						<button className="btn" onClick={() => this.handleFragenCheckClick()}>Checken...</button>}
						{this.state.phase === 'auswertungsphase' &&
							<button
							className="btn"
							disabled={this.state.phase !== 'auswertungsphase' ? true : false }
							onClick={() => this.handleWeiterClick()}>Weiter</button>}
						{this.fahrerVorhanden() && !this.state.abschluss &&
						<button
							className="btn"
							onClick={() => this.setState({videoSeen: false})}>nochmal ansehen</button>
						}
						</div>
						<div id="space_below" className="w-100 row" style={{backgroundColor: '#fff', height: '220px'}}>
						</div>
					</React.Fragment>
				}
				{this.fahrerVorhanden() &&  this.state.videoSeen && this.state.abschluss &&
				<div className="h4 p-3 text-warning">Alle Antworten waren korrekt!<br/>Gute Fahrt mir dem »schlauen Blauen«!</div>}
				{!this.fahrerVorhanden() &&
				<div className="h4 p-3 text-warning">Der Link ist nicht korrekt.<br/>Bitte verwenden Sie den Link aus der Email, die Sie bekommen haben.</div>}
			</div>
		);
	}

	render () {
		return (
			<React.Fragment>
				{this.renderContent()}
				{//{this.fahrerVorhanden() && !this.state.abschluss &&
				}
				{(1 === 2) &&
				<button
					className="btn"
					onClick={this.handleVideoEnded}>v z e</button>}
				</React.Fragment>
		)
	}
}

const mapDispatchToProps = {
	reportVideoSeen,
	fetchFahrerByUuid
}

function mapStateToProps(state) {
	return {
		fahrer: state.fahrer
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoDisplay);



// WEBPACK FOOTER //
// ./src/components/video/VideoDisplay.js